var _rect, _rect2, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImageEmptyState(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 110,
    height: 110,
    viewBox: "0 0 110 110",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 109,
    height: 109,
    rx: 5.5,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 109,
    height: 109,
    rx: 5.5,
    stroke: "#C7C7CC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M54.4998 28.416C47.404 28.416 41.6353 34.1848 41.6353 41.2806C41.6353 48.241 47.079 53.8743 54.1748 54.1181C54.3915 54.091 54.6082 54.091 54.7707 54.1181C54.8248 54.1181 54.8519 54.1181 54.9061 54.1181C54.9332 54.1181 54.9332 54.1181 54.9603 54.1181C61.8936 53.8743 67.3373 48.241 67.3644 41.2806C67.3644 34.1848 61.5957 28.416 54.4998 28.416Z",
    fill: "#292D32"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M68.2581 61.323C60.7019 56.2855 48.3789 56.2855 40.7685 61.323C37.3289 63.6251 35.4331 66.7397 35.4331 70.071C35.4331 73.4022 37.3289 76.4897 40.7414 78.7647C44.5331 81.3105 49.5164 82.5835 54.4998 82.5835C59.4831 82.5835 64.4664 81.3105 68.2581 78.7647C71.6706 76.4626 73.5664 73.3751 73.5664 70.0168C73.5394 66.6855 71.6706 63.598 68.2581 61.323Z",
    fill: "#292D32"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImageEmptyState);
export default __webpack_public_path__ + "static/media/ImageEmptyState.89e0f1ce78397f1d2832c4ad2930f18a.svg";
export { ForwardRef as ReactComponent };